export const searchConstants = {
	GET_FILTERED_SUCCESS: 'GET_FILTERED_CONTENT_SUCCESS',
	GET_FILTERED_REQUEST: 'GET_FILTERED_CONTENT_REQUEST',
	GET_FILTERED_FAILURE: 'GET_FILTERED_CONTENT_FAILURE',
	RESET_FILTERED: 'RESET_FILTERED_CONTENT',
	LOAD_MORE_FILTERED_SUCCESS: 'LOAD_MORE_FILTERED_CONTENT_SUCCESS',
	LOAD_MORE_FILTERED_REQUEST: 'LOAD_MORE_FILTERED_CONTENT_REQUEST',
	LOAD_MORE_FILTERED_FAILURE: 'LOAD_MORE_FILTERED_CONTENT_FAILURE'
}
